import { render, staticRenderFns } from "./fbimagebox.vue?vue&type=template&id=1ff050fd&scoped=true&"
import script from "./fbimagebox.vue?vue&type=script&lang=js&"
export * from "./fbimagebox.vue?vue&type=script&lang=js&"
import style0 from "./fbimagebox.vue?vue&type=style&index=0&id=1ff050fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff050fd",
  null
  
)

export default component.exports